import { Component, Input } from '@angular/core';
import { PartnerOrdersComponent } from 'app/partner';

@Component({
    selector: 'partner-orders-filter',
    templateUrl: './partner-orders-filter.component.html',
    styleUrls: ['./partner-orders-filter.component.scss']
})
export class PartnerOrdersFilterComponent {
    @Input()
    public parent!: PartnerOrdersComponent;
}
